/**
 * Enum für das Besuchen eines Navigationsknoten verwendet in NavigationNodeTreeHelper
 * @readonly
 * */
export enum VisitNodeResponseE {
    Continue,
    Skip,
    Return
}